import { render, staticRenderFns } from "./ShootingGalleryItem.vue?vue&type=template&id=95f0b39e&scoped=true"
import script from "./ShootingGalleryItem.vue?vue&type=script&lang=js"
export * from "./ShootingGalleryItem.vue?vue&type=script&lang=js"
import style0 from "./ShootingGalleryItem.vue?vue&type=style&index=0&id=95f0b39e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f0b39e",
  null
  
)

export default component.exports